import { BaSeHeading3, BaSeParagraph } from "@base/react"
import PostCreditTable from "./postCreditTable";
import ApiPlannings from "../../services/planning";
import Loading from "../../components/loading";
import InputSelect from "../../components/select";
import { useEffect, useState, useCallback, useContext } from "react";
import './index.scss';
import { useParams } from "react-router-dom";
import moment from "moment";
import {eventTag, getCurrentCNPJ} from "../../services/utils";
import { AppContext } from "../../context/app";

const apiPlannings = ApiPlannings();
const eventGA = {
  name: "planning",
  category: "post_credit",
  action: "click",
}
const PostCredit = () => {
  const { companies } = useContext(AppContext);
  const { postCreditId } = useParams();
  const [plannings, setPlannings] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [monthsAmount, setMonthsAmount] = useState(0);
  const [startMonth, setStartMonth] = useState(moment().month() + 1);
  const [startYear, setStartYear] = useState(moment().year());
  const [loading, setLoading] = useState(true);
  const [loadingClients, setLoadingClients] = useState(true);
  const activeCompanyCnpj = getCurrentCNPJ(companies);

  const getPlannings = useCallback(async () => {
    try {
      setLoading(true);
      const params = selectedClient
        ? { document: selectedClient }
        : postCreditId
          ? { post_credit: postCreditId }
          : {};
      const { data } = await apiPlannings.listPostCreditJourney(params)
      setPlannings(data);
      eventTag(eventGA?.name, eventGA?.category, "submit", "Listando jornadas de pós crédito")
      let minMonthIndex = Infinity;
      let maxMonthIndex = -Infinity;

      data.forEach(item => {
        item.months?.forEach((month) => {
          const absoluteIndex = month.year * 12 + month.month;
          minMonthIndex = Math.min(minMonthIndex, absoluteIndex);
          maxMonthIndex = Math.max(maxMonthIndex, absoluteIndex);
        });
      });

      const totalMonths = maxMonthIndex - minMonthIndex + 1;
      setMonthsAmount(totalMonths < 0 ? 0 : totalMonths);

      if (minMonthIndex !== Infinity) {
        setStartMonth(minMonthIndex % 12 || 12);
        setStartYear(Math.floor(minMonthIndex / 12) - (minMonthIndex % 12 === 0 ? 1 : 0));
      }
    } catch (err) {
      console.warn("ERROR => ", err);
    } finally {
      setLoading(false);
    }
  }, [postCreditId, selectedClient]);

  const getPostCreditClients = useCallback(async () => {
    try {
      setLoadingClients(true);
      const { data } = await apiPlannings.listPostCreditClients(activeCompanyCnpj);
      const formattedClients = (data || []).map((client) => ({
          value: client.document,
          label: client.name,
          subspan: client.linked ? "(minha empresa)" : "",
        }));

      setClientOptions(formattedClients);
      setSelectedClient((currentSelectedClient) => {
        if (!currentSelectedClient) return currentSelectedClient;

        const clientStillExists = formattedClients.some(
          (client) => client.value === currentSelectedClient
        );

        return clientStillExists ? currentSelectedClient : null;
      });
    } catch (err) {
      console.warn("ERROR => ", err);
    } finally {
      setLoadingClients(false);
    }
  }, [activeCompanyCnpj]);

  useEffect(() => {
    getPlannings();
  }, [getPlannings]);

  useEffect(() => {
    getPostCreditClients();
  }, [getPostCreditClients]);

  if (loading) {
    return <Loading fullPage />;
  }

  const postCreditAmount = plannings.length;

  return (
    <div className="post-credit-page">
      <div className="post-credit-header">
        <div className="post-credit-filter">
          <BaSeHeading3 isBold>
            Jornadas Pós-Crédito ({postCreditAmount})
          </BaSeHeading3>
          <InputSelect
            options={clientOptions}
            value={selectedClient}
            onChange={(value) => setSelectedClient(value)}
            placeholder={loadingClients ? "Carregando clientes..." : "Selecione"}
            noResultsText="Nenhum cliente encontrado"
            disabled={loadingClients}
            className="post-credit-filter__select"
          />
        </div>
        <BaSeParagraph>
          O pós-crédito do Crédito Consciente Sebrae acompanha mensalmente os resultados da sua empresa,
          comparando o planejado com o realizado, e monitorando indicadores-chave para apoiar sua gestão.
        </BaSeParagraph>
      </div>
      <PostCreditTable
        plannings={plannings}
        monthsAmount={monthsAmount}
        startMonth={startMonth}
        startYear={startYear}
        openedPlanning={Number(postCreditId)}
        refreshPlannings={getPlannings}
        eventGA={eventGA}
      />
    </div>
  );
};

export default PostCredit;
